/**
 * Adds prev/next arrow buttons overlaid on the product media area.
 * Dawn ships thumbnails but no arrows on the main image; this augments
 * the built-in <media-gallery> with keyboard + on-image navigation.
 *
 * Wiring: clicking prev/next locates the currently active thumbnail,
 * finds its neighbor, and clicks it — which triggers all of Dawn's
 * existing gallery-switching logic (media swap, active class, etc.).
 * Also supports left/right arrow keys on the whole product page.
 */

(function () {
  function initArrows(gallery) {
    if (gallery.dataset.arrowsInit) return;
    gallery.dataset.arrowsInit = '1';

    // Dawn's thumbnails: <li class="thumbnail-list__item" data-target="..."> with a <button class="thumbnail" aria-current="true|false"> inside
    const thumbnails = Array.from(gallery.querySelectorAll('.thumbnail-list__item[data-target]'));
    if (thumbnails.length < 2) return; // no arrows if only one image

    const mediaViewer = gallery.querySelector('slider-component[id^="GalleryViewer"]')
      || gallery.querySelector('.product__media-list')
      || gallery.querySelector('.slider.product__media-list')
      || gallery.querySelector('.grid.product__media-list')
      || gallery;

    const overlay = document.createElement('div');
    overlay.className = 'product-media-arrows';
    overlay.innerHTML = `
      <button type="button" class="product-media-arrows__btn product-media-arrows__btn--prev" aria-label="Previous image">
        <svg viewBox="0 0 24 24" fill="none" width="20" height="20" aria-hidden="true"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
      <button type="button" class="product-media-arrows__btn product-media-arrows__btn--next" aria-label="Next image">
        <svg viewBox="0 0 24 24" fill="none" width="20" height="20" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
    `;

    // Insert overlay as sibling of media viewer so it can position absolutely against it
    const container = mediaViewer.parentElement;
    if (getComputedStyle(container).position === 'static') container.style.position = 'relative';
    container.appendChild(overlay);

    function currentIndex() {
      // Dawn marks the active thumbnail via aria-current="true" on the inner <button class="thumbnail">.
      const active = thumbnails.findIndex((li) => {
        const btn = li.querySelector('.thumbnail');
        return btn && btn.getAttribute('aria-current') === 'true';
      });
      return active >= 0 ? active : 0;
    }

    function go(delta) {
      const from = currentIndex();
      const to = (from + delta + thumbnails.length) % thumbnails.length;
      const clickable = thumbnails[to].querySelector('.thumbnail, a, button, [role="button"]');
      if (clickable) clickable.click();
    }

    overlay.querySelector('.product-media-arrows__btn--prev').addEventListener('click', (e) => { e.preventDefault(); go(-1); });
    overlay.querySelector('.product-media-arrows__btn--next').addEventListener('click', (e) => { e.preventDefault(); go(1); });

    // Keyboard nav — arrows only when focus isn't in an input
    document.addEventListener('keydown', (e) => {
      if (!document.body.contains(gallery)) return;
      const tag = (document.activeElement && document.activeElement.tagName) || '';
      if (['INPUT', 'TEXTAREA', 'SELECT'].includes(tag) || document.activeElement?.isContentEditable) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });
  }

  function boot() {
    document.querySelectorAll('media-gallery').forEach(initArrows);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Re-init on Shopify section-editor reload
  document.addEventListener('shopify:section:load', boot);
})();
